import _ from "underscore";

function max(...args) {
  args.pop();
  return Math.max(..._.flatten(args).map(value => parseFloat(value)));
}

export default max;
